import ChefBlogShow from './ChefBlogShow'

export default ChefBlogShow



// WEBPACK FOOTER //
// ./src/features/RestaurantAndCafe/containers/ChefBlogShow/index.js